module.exports = __webpack_public_path__ + "img/thitch_logo.65f1fe1c.png";